<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-1">
<h1 id="part-2-witnesses" style="font-family:Arial; padding-top:200px">Part 2:<br/> Witnesses</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?70f0c38f